import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  GeneralContainer,
  ButtonBack,
  ContainerBack,
  ContentBack,
  ContentText,
  SpanForm,
  SpanCaseId,
  SpanCreationDate,
  Hr,
} from "./MyInsightDetailContainer.styled";
import { ReactComponent as BackArrow } from "../../themes/Icons/back_arrow.svg";
import MyInsightDetailComponent from "../../components/MyInsightDetailComponent/MyInsightDetailComponent";
import { clientPolicyIngsight } from "../../App";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CASE_BY_ID,
  COMMENTS_BY_CASE_ID,
  NEXT_CASE_STATUSES_BY_CASE,
  PERMISSIONS_BY_CASE,
} from "../../GraphQL/Queries";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { theme as themeConfig } from "../../themes/themes";
import {
  CHANGE_STATUS_CASE,
  CHANGE_STATUS_CASE_COMMENT,
  CREATE_CASE_COMMENT,
  UPDATE_CASE_COMMENT,
} from "../../GraphQL/Mutations";
import ModalConfirmCaseUpdated from "../../components/ModalConfirmCaseUpdated/ModalConfirmCaseUpdated";

const MyInsightDetailContainer = () => {
  const location = useLocation();
  const history = useHistory();
  const [detail, setDetail] = useState({});
  const [caseDetail, setCaseDetail] = useState({});
  const [comments, setComments] = useState([]);
  const [renderAgain, setrenderAgain] = useState(false);
  const [isEditComment, setIsEditComment] = useState(false);
  const [commentData, setCommentData] = useState();
  const [openAlert, setOpenAlert] = useState(null);
  const [modalAlertTitle, setModalAlertTitle] = useState(false);
  const [actionsList, setActionsList] = useState([]);
  const [actionSelected, setActionSelected] = useState(null);
  const [permissions, setPermissions] = useState([]);

  const [changeStatusCase] = useMutation(CHANGE_STATUS_CASE, {
    client: clientPolicyIngsight,
  });
  const [createCaseComment] = useMutation(CREATE_CASE_COMMENT, {
    client: clientPolicyIngsight,
  });
  const [updateCaseComment] = useMutation(UPDATE_CASE_COMMENT, {
    client: clientPolicyIngsight,
  });
  const [changeStatusCaseComment] = useMutation(CHANGE_STATUS_CASE_COMMENT, {
    client: clientPolicyIngsight,
  });

  const [runQueryCaseById] = useLazyQuery(CASE_BY_ID, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.caseById) {
        setCaseDetail({ ...data.caseById });
      }
    },
  });

  const [runQueryNextCaseStatusesByCase] = useLazyQuery(
    NEXT_CASE_STATUSES_BY_CASE,
    {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data?.nextCaseStatusesByCase) {
          let allActionsByCase = data.nextCaseStatusesByCase.map((item, i) => {
            return { value: item.idCaseStatus, label: item.statusName };
          });
          setActionsList([...allActionsByCase]);
        }
      },
    }
  );

  const [runQueryPermissionsByCase] = useLazyQuery(PERMISSIONS_BY_CASE, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.permissionsByCase) {
        setPermissions(data.permissionsByCase);
      }
    },
  });

  const [runQueryCommentsByCaseId] = useLazyQuery(COMMENTS_BY_CASE_ID, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.commentsByCaseId) {
        setComments([...data.commentsByCaseId]);
      }
    },
  });

  const handleGoBack = () => {
    history.push({ pathname: "/MyInsights", state: { tab: 1 } });
  };

  let handleChangeSelectAction = (action) => {
    setActionSelected(action);
  };

  let handleSaveAction = (data) => {
    if (actionSelected) {
      changeStatusCase({
        variables: {
          caseId: detail.idCase,
          newCaseSatus: `${actionSelected.label
            .toUpperCase()
            .replaceAll(" ", "_")}`,
        },
      })
        .then((res) => {
          if (res.data.changeStatusCase) {
            NotificationManager.success(
              "Case status is updated successfully",
              "",
              5000
            );
            setOpenAlert(null);
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let handleCreateComment = (data) => {
    if (data.idCase && data.comment) {
      createCaseComment({
        variables: {
          idCase: data.idCase,
          comment: data.comment,
        },
      })
        .then((res) => {
          if (res.data.createCaseComment) {
            NotificationManager.success(
              "Comment is created successfully",
              "",
              5000
            );
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let handleUpdateComment = (data, smiley, ilike) => {
    if (data.idCaseComment && data.comment) {
      updateCaseComment({
        variables: {
          idCaseComment: data.idCaseComment,
          comment: data.comment,
          smiley: smiley ? `${smiley}` : "",
          ilike: ilike ? `${ilike}` : "",
        },
      })
        .then((res) => {
          if (res.data.updateCaseComment) {
            NotificationManager.success(
              "Comment is updated successfully",
              "",
              5000
            );
            setIsEditComment(false);
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  let handleCancelUpdateComment = () => {
    setIsEditComment(!isEditComment);
  };

  let handleSendChanges = (data) => {
    if (isEditComment) {
      NotificationManager.warning(
        "You haven't saved the changes on your comments",
        "",
        5000
      );
    } else {
      setOpenAlert(data);
      setModalAlertTitle(true);
    }
  };

  let handleEditComment = (item) => {
    setIsEditComment(!isEditComment);
    if (item.idCaseComment) {
      setCommentData({
        idCase: item.idCase,
        idCaseComment: item.idCaseComment,
        comment: item.comment,
      });
    }
  };

  let handleDeleteComment = (data) => {
    if (data.idCaseComment && data.comment) {
      changeStatusCaseComment({
        variables: {
          idCaseComment: data.idCaseComment,
          newCommentStatus: "DELETED",
        },
      })
        .then((res) => {
          if (res.data.changeStatusCaseComment) {
            NotificationManager.success(
              "Comment is deleted successfully",
              "",
              5000
            );
            setrenderAgain(!renderAgain);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  useEffect(() => {
    if (location.state.detail) {
      setDetail(location.state.detail);
    }
  }, []);

  useEffect(() => {
    if (detail?.idCase) {
      runQueryCaseById({
        variables: {
          caseById: detail.idCase,
        },
      });
      runQueryCommentsByCaseId({
        variables: {
          idCase: detail.idCase,
        },
      });
      runQueryNextCaseStatusesByCase({
        variables: {
          caseId: detail.idCase,
        },
      });
      runQueryPermissionsByCase({
        variables: {
          caseId: detail.idCase,
        },
      });
    }
  }, [detail, renderAgain]);

  return (
    <GeneralContainer>
      <ContainerBack>
        <ContentBack>
          <ButtonBack className="m-3" onClick={() => handleGoBack()}>
            <BackArrow></BackArrow>
          </ButtonBack>
          <ContentText>
            <div>
              {caseDetail?.idFormNavigation?.name && (
                <SpanForm>{`${caseDetail.idFormNavigation.name}`}</SpanForm>
              )}
              <span style={{ margin: "0.5em" }}>|</span>
              {caseDetail?.idCase && (
                <SpanCaseId>ID: {caseDetail.idCase}</SpanCaseId>
              )}
            </div>

            {caseDetail?.createDate && (
              <SpanCreationDate>
                Creation date:{" "}
                {moment(caseDetail.createDate).format("YYYY-MM-DD")}
              </SpanCreationDate>
            )}
          </ContentText>
        </ContentBack>
      </ContainerBack>
      <Hr className="ml-1" color={themeConfig.text.primary} />
      <MyInsightDetailComponent
        comments={comments}
        policyQuestionAnswers={caseDetail.policyQuestionAnswers}
        idCase={caseDetail.idCase}
        caseStatus={caseDetail.status}
        commentData={commentData}
        setCommentData={setCommentData}
        isEditComment={isEditComment}
        handleCreateComment={handleCreateComment}
        handleUpdateComment={handleUpdateComment}
        handleEditComment={handleEditComment}
        handleDeleteComment={handleDeleteComment}
        handleCancelUpdateComment={handleCancelUpdateComment}
        handleSendChanges={handleSendChanges}
        permissions={permissions}
      />
      {openAlert && (
        <ModalConfirmCaseUpdated
          modalTitle={"Alert"}
          title={
            modalAlertTitle
              ? "Cases Successfully Updated"
              : "Cases Error for Update"
          }
          modalAlertTitle={modalAlertTitle}
          labelSelect={"Please select the next action for this case:"}
          actionsList={actionsList}
          actionSelected={actionSelected}
          handleChangeSelectAction={handleChangeSelectAction}
          setOpen={setOpenAlert}
          open={openAlert}
          fn={handleSaveAction}
          isLockerSelector={
            permissions
              .map((item) => item.actionName)
              .indexOf("ChangeStatus") !== -1
              ? false
              : true
          }
        />
      )}
    </GeneralContainer>
  );
};

export default MyInsightDetailContainer;
